import { render, staticRenderFns } from "./AppPhoneInput.vue?vue&type=template&id=504e9c54&"
import script from "./AppPhoneInput.vue?vue&type=script&lang=js&"
export * from "./AppPhoneInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports